import { FC, SyntheticEvent, useCallback } from 'react'
import { Button, ButtonProps, ButtonVariants } from '@/components/Button'
import { handleNavigation } from '@/components/Link/hooks'
import { useExternalNavigation } from '@/hooks/useAnalytics'
import { useRouter } from 'next/navigation'
import { Colour } from '../constants'

const url = 'https://web.mettle.co.uk/'

export const LogInButton: FC<ButtonProps> = ({
  // oxlint-disable-next-line no-unused-vars
  id = 'unknown',
  text,
  smallText,
  ...buttonProps
}) => {
  const logExternalNavigation = useExternalNavigation()
  const router = useRouter()

  const navigate = useCallback(() => {
    logExternalNavigation(url, true)
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    handleNavigation(router, url)({} as SyntheticEvent<any>)
    // oxlint-disable-next-line
  }, [])

  return (
    <Button
      smallText={smallText}
      {...buttonProps}
      variant={ButtonVariants.SECONDARY}
      url={url}
      backgroundColour={Colour.softBlack}
      onClick={navigate}
    >
      {text}
    </Button>
  )
}
